import _ from 'lodash'

const ACCORDION_CONFIG = {
    accordions: _.selectAll( '.c-accordion' )
}

export default ACCORDION_CONFIG